import { SkillBase, SkillBaseResource } from '../@competentNL/Skills/Skills';
import { Competency } from '../Competencies/Competencies';
import { OrganisationOccupationOverviewItem, OrganisationOccupationOverviewItemResource } from '../OrganisationOccupationOverview/OrganisationOccupationOverview';

export interface OrganisationOccupationResource extends OrganisationOccupationOverviewItemResource {
    skills: {
        id: string;
        label: string;
    }[];
    cnlSkills: SkillBaseResource[];
    competencies: {
        id: string;
        label: string;
    }[];
}

export interface OrganisationOccupation extends OrganisationOccupationOverviewItem {
    escoSkills: SkillBase[];
    skills: SkillBase[];
    competencies: Competency[];
}

export interface AddOrganisationOccupationRequest {
    organisationUuid: string;
    title: string;
    description: string;
}

export interface EditOrganisationOccupationRequest extends AddOrganisationOccupationRequest {
    id: string;
    skills: string[];
    cnlSkills: string[];
    competencies: string[];
}

export interface OrganisationOccupationFormData {
    id?: string;
    title: string;
    description: string;
    escoSkills: string[]; // TODO CompetentNL: Esco skills are legacy
    skills: string[];
    competencies: string[];
}

export const defaultOrganisationOccupation = (): OrganisationOccupation => ({
    id: '',
    title: '',
    description: '',
    escoSkills: [],
    skills: [],
    competencies: [],
});
